import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const TikTok: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                d="M15.1428571,6.56 C13.7657143,6.56571429 12.4228571,6.13142857 11.3028571,5.33142857 L11.3028571,10.92 C11.3028571,13.7257143 9.02857143,16 6.22285714,16 C3.41714286,16 1.14285714,13.7257143 1.14285714,10.92 C1.14285714,8.11428571 3.41714286,5.84 6.22285714,5.84 C6.45714286,5.84 6.68571429,5.85714286 6.92,5.88571429 L6.92,8.69714286 C5.69142857,8.30857143 4.38285714,8.99428571 3.99428571,10.2228571 C3.60571429,11.4514286 4.29142857,12.76 5.52,13.1485714 C6.74857143,13.5371429 8.05714286,12.8514286 8.44571429,11.6228571 C8.51428571,11.3942857 8.55428571,11.16 8.55428571,10.9257143 L8.55428571,0 L11.3028571,0 C11.3028571,0.234285714 11.32,0.462857143 11.36,0.691428571 L11.36,0.691428571 C11.5542857,1.72571429 12.16,2.62857143 13.0457143,3.2 C13.6685714,3.61142857 14.3942857,3.82857143 15.1371429,3.82857143 L15.1371429,6.56 L15.1428571,6.56 Z"
                fill="currentColor"
                fillRule="nonzero"
            ></path>
        </Icon>
    );
};
